import React from 'react';
import { View } from 'react-native';

import ProgressBar from './progressBar';
import StatusText from './statusText';
import { Gauge } from '@components/common/CircleBar';
import i18n from 'i18n-js';
import { getOEEColor } from '@components/wallboard/helpers';
import { WALLBOARD_GAUGE_CONFIG, WALLBOARD_TILE_LAYOUT } from '@components/wallboard/constants';
import useManageNotProductiveTile from '@components/wallboard/hooks/useManageNotProductiveTile';

export default ({
  timeOffset,
  formatSinceTime,
  scale,
  C,
  font,
  ncFileStatuses,
  Svg,
  machineStatus,
  is24HourFormat,
  tileHeight,
  getWallboardEventTimeline,
  machineId,
  timeLine,
  localTime,
  tileWidth,
  oeeValue,
}) => {
  const {
    lineHeight,
    icon,
    title,
    ncFile,
    runningTitle,
    runningTime,
    showSinceLabel,
    isIgnoreStatus,
    isSetupStatus,
    isNoNCFileStatus,
  } = useManageNotProductiveTile({
    timeOffset,
    formatSinceTime,
    ncFileStatuses,
    machineStatus,
    is24HourFormat,
    tileHeight,
  });

  return (
    <View style={{ alignContent: 'center', width: '100%', flex: 1 }}>
      <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center' }}>
        {icon ? (
          <View style={{ width: '100%', alignItems: 'center', marginBottom: isIgnoreStatus || isSetupStatus ? 0 : scale(17) }}>
            <Svg icon={icon.name} height={scale(icon.height)} width={scale(icon.width)} color={icon?.color ?? 'Label/Light/Quaternary'} />
          </View>
        ) : null}

        <StatusText {...{ font, scale, C }} text={title} style={{ marginVertical: isNoNCFileStatus ? scale(42) : 0 }} />

        <StatusText {...{ font, scale, C }} text={ncFile} style={{ marginVertical: isIgnoreStatus || isSetupStatus ? 0 : scale(10) }} />

        <StatusText {...{ font, scale, C }} text={runningTitle} />

        {showSinceLabel ? <StatusText {...{ font, scale, C }} text={'since'} /> : null}

        <StatusText {...{ font, scale, C }} text={runningTime} />
      </View>

      <View
        style={{
          height: tileHeight * WALLBOARD_TILE_LAYOUT.BOTTOM_SECTION_HEIGHT_RATIO,
          justifyContent: 'flex-end',
          paddingHorizontal: scale(10),
          paddingBottom: scale(10),
        }}
      >
        <ProgressBar
          {...{
            scale,
            C,
            tileWidth,
            font,
            machineStatus,
            getWallboardEventTimeline,
            machineId,
            timeLine,
            localTime,
            lineHeight,
          }}
          style={{ height: scale(16) + lineHeight + Math.ceil(lineHeight / 4), paddingTop: 0 }}
        />

        <View style={{ alignItems: 'center', marginTop: scale(11.5) }}>
          <View style={{ width: (tileWidth - 4 * scale(10)) / 3 }}>
            <Gauge
              containerStyle={{ backgroundColor: C('Gray/Light/4-7') }}
              label={i18n.t('OEE Today')}
              value={oeeValue != null ? String(Math.round(oeeValue)) : '--'}
              suffix={oeeValue != null ? '%' : undefined}
              progress={oeeValue != null ? Math.round(oeeValue) / 100 : 0}
              arcColor={oeeValue != null ? getOEEColor(Math.round(oeeValue), C) : C('Background/Light/Chart')}
              valueColor={oeeValue != null ? getOEEColor(Math.round(oeeValue), C) : undefined}
              noData={oeeValue == null}
              size={scale(WALLBOARD_GAUGE_CONFIG.GAUGE_SIZE)}
              scale={scale}
              font={font}
              C={C}
            />
          </View>
        </View>
      </View>
    </View>
  );
};
